import StatusPill, { STATUS_PILL_VARIANT } from '../status-pill/StatusPill';

// Marks the first inspection of an asset.
const NewPill = (props) => (
  <StatusPill variant={STATUS_PILL_VARIANT.INFO} {...props}>
    New
  </StatusPill>
);

export default NewPill;
